import React from "react";

const Clone = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M29.724 8.142 22.08.498C21.796.213 21.262 0 20.87 0h-9.492C9.813 0 8.533 1.138 8.533 2.595V3.77h2.845a.88.88 0 0 1 .889-.89h7.288v4.979a2.853 2.853 0 0 0 2.845 2.844h4.978v12.444a.88.88 0 0 1-.89.89h-3.733v2.844h4.623a2.853 2.853 0 0 0 2.844-2.845V9.351c0-.391-.213-.925-.498-1.21v.001Zm-7.324-.32v-2.95l2.951 2.95H22.4Z"
        />
        <path
            fill={fill}
            d="M0 8v21.155A2.853 2.853 0 0 0 2.845 32h15.644a2.853 2.853 0 0 0 2.844-2.845V14.508c0-.391-.213-.925-.497-1.21L13.19 5.654c-.284-.284-.818-.497-1.209-.497H2.845A2.853 2.853 0 0 0 0 8Zm13.511 2.027 2.951 2.95h-2.95v-2.95ZM3.733 8h6.934v4.978a2.853 2.853 0 0 0 2.844 2.844h4.978v12.445a.88.88 0 0 1-.89.889H3.734a.88.88 0 0 1-.889-.89V8.89A.88.88 0 0 1 3.734 8Z"
        />
    </svg>
);

export default Clone;